export const popupModel = {};
